import {Ordering, OrderingOptions} from '../../../interfaces';

/**
 * No ordering options for ordering
 */
export interface NoOrderingOptions extends OrderingOptions
{
}

/**
 * Public API for no ordering
 */
export interface NoOrdering extends Ordering
{
}